module.exports = __webpack_public_path__ + "static/Canela-ThinItalic-Web-87a4826cdbef036f6717a2abe959d34b.woff2";